<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findCompanyUser"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :multiple="multiple"
            :disabled="disabled"
            :readonly="readonly"
            :creatable="creatable"
            :placeholder="placeholder"
            :prop="prop"
            key-id="_id"
            key-label="fullName"
            @change="handleChange"
            @create-new="openCreate" />

        <add-company-user
            ref="addCompanyUser"
            :list-company-group="groupList"
            @newData="(data) => handleCreateSuccess(data)" />
    </div>
</template>

<script lang="ts" setup>
import AddCompanyUser from '../../pages/trucker-[id]/company/user-group/-components/add-company-user.vue'
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  creatable: { type: Boolean, default: false },
  name: { type: String, default: '' },
  groupType: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  dataCreateDefault: {
    type: Object,
    default: () => {}
  },
  label: { type: String, default: () => '' }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const { dataCreateDefault } = toRefs(props)

const groupList = ref<Array<{ [key: string]: any }>>([])

const addCompanyUser = ref()

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const cText = computed({
  get () {
    return name.value
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const { modelValue, name, required, multiple, label, disabled, groupType } = toRefs(props)
const findCompanyUser = async (s: string) => {
  const api = $url.company.selectCompanyUser

  const res = await $api(api, { uriParams: { KEY: s, GROUPTYPE: groupType.value } })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return null
}

const dataCreate = computed(() => {
  if (!dataCreateDefault.value) {
    return {}
  }

  const { fullName, phone, email } = dataCreateDefault.value

  return {
    fullName: fullName || '',
    phone: $lodash.cloneDeep(phone) || {
      code: '+84',
      phone: '',
      countryCode: 'Vietnam +84'
    },
    email: email || ''
  }
})

const openCreate = () => {
  getGroup()
  if (addCompanyUser.value) {
    addCompanyUser.value.open(dataCreate.value)
  }
}

const handleCreateSuccess = (data: any) => {
  cValue.value = data?._id || ''
  cText.value = data?.fullName || ''
}

const getGroup = () => {
  $api($url.companyGroup.getAllGroup)
    .then((data: any) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      groupList.value = responseData.data.rows
    })
    .catch((error: any) => error)
}

const handleChange = (val: any) => {
  emits('change', val)
}
</script>
